<template>
    <component
        v-if="type"
        :is="type"
        :product="product"
        :formId="formId"
        :formValid="formValid"
        :formValues="formValues" />
</template>
<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, computed, PropType } from 'vue';
    import { useStore } from '@/store';
    import { AnyProduct } from '@shared/interfaces/product';
    import { ProductType } from '@/api/Cart/cart.interfaces';
    import { FormValues } from '@ui/components/FormV2/Form.interfaces';
    import Hotel from './Variants/Hotel.vue';
    import Flight from './Variants/Flight.vue';
    import Ferry from './Variants/Ferry.vue';

    export default defineComponent({
        name: 'Copy',
        methods: { t },
        components: { Hotel, Flight, Ferry },
        props: {
            productId: { type: String, required: true },
            formId: { type: String, required: true },
            formValid: { type: Boolean, required: true },
            formValues: { type: Object as PropType<FormValues | null> },
        },
        setup(props) {
            const store = useStore();

            const product = computed<AnyProduct>(() =>
                store.getters['cart/getProduct'](props.productId)
            );

            const type = computed(() => {
                switch (product.value.Type) {
                    case ProductType.Hotel:
                    case ProductType.Flight:
                    case ProductType.Ferry:
                        return product.value.Type;
                    default:
                        return null;
                }
            });

            return { product, type };
        },
    });
</script>
